<button type="button" ngbAutofocus class="fs-close-btn right border-0 bg-transparent p-0" (click)="close()" aria-label="close">
  <fa-icon icon="times-circle" class="circle-icon-btn" aria-hidden="true"></fa-icon>
</button>

<div class="modal-body clear text-center">
  <h2 class="m-b-20">Bonus!</h2>
  <p class="m-b-20">
    You received the following bonus {{ gifts.length === 1 ? 'product' : 'products' }} for registering <strong>{{ registeredProductName }}</strong>:
  </p>
  <div class="m-b-30">
    @for (gift of gifts; track gift.gift_id) {
      <div class="p-10 m-b-10" style="border: 1px solid var(--border-color); border-radius: 8px;">
        <strong>{{ gift.gift_title }}</strong>
        @if (gift.gift_description) {
          <p class="m-t-5 text-muted small">{{ gift.gift_description }}</p>
        }
      </div>
    }
  </div>
  <p class="text-muted small m-b-20">These products have been added to your account.</p>
  <button class="btn btn-primary" (click)="close()">Got it!</button>
</div>
